// Phase 7 — Mugizh-admin Dashboard (static mockup) migrated to shadcn/Tailwind.
//
// No dispatch/API — it renders hardcoded performance figures. UI only: the legacy
// image-based performance cards become Stripe-style StatCards. The first card keeps
// its navigate to the orders list (the only interactive behaviour in the legacy).
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TrendingUp } from 'lucide-react';
import { PageHeader } from '../shared/page-header';
import { StatCard } from '../shared/stat-card';

const DashBoard = () => {
  const navigate = useNavigate();

  const cards = Array.from({ length: 7 });

  return (
    <div className="mz h-full overflow-y-auto px-6 py-4">
      <PageHeader title="Dashboard" />
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
        {cards.map((_, index) => (
          <div
            key={index}
            className={index === 0 ? 'cursor-pointer' : undefined}
            onClick={index === 0 ? () => navigate('/mugizh-admin/my-orders-list') : undefined}
          >
            <StatCard label="Today’s Sale" value="₹10,000" caption="+ growth" trend="up" icon={TrendingUp} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default DashBoard;
